import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TiposSakesService } from '../../../../services/tipos_sakes.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-tipo-sake',
  templateUrl: './tipo-sake.component.html',
  styleUrls: ['./tipo-sake.component.scss'],
})
export class TipoSakeComponent implements OnInit {
  form = this.fb.group({
    nombre: [
      '',
      [
        Validators.required,
        Validators.maxLength(15),
        Validators.pattern(/^[ñA-Za-z _]*[ñA-Za-z][ñA-Za-z _]*$/),
      ],
    ],
    id_usuarios_creador: [sessionStorage.getItem('id_usuario')],
    estatus: [true],
  });
  constructor(
    public dialogRef: MatDialogRef<TipoSakeComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public tiposSakesService: TiposSakesService,
    private _snackBar: MatSnackBar
  ) {}
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  ngOnInit(): void {}

  onSubmit() {
    this.form.controls.id_usuarios_creador.setValue(
      sessionStorage.getItem('id_usuario')
    );
    this.form.value.id_canales = sessionStorage.getItem('id_canales');
    this.form.value.borrado = 0;
    //console.log(this.form.value);
    this.tiposSakesService.crear(this.form.value).subscribe((data) => {
      //console.log(data);
      this.openSnackBar('Tipo Operación creado con éxito', 'X');
      this.dialogRef.close();
    });
  }
}
